import type { OtherInputField } from "@lib/config/form";

type FormSelectProps = OtherInputField;

export function FormSelect(_props: FormSelectProps) {
  return "Select";
}
